import secureApi from '../../utils/secureApi';

export async function addBanner(payload: any): Promise<any> {
  const response = await secureApi.post<any>(
    `/api/v1/tournaments/admin/banners/add`,
    payload
  );
  
  // Handle API response structure: may be wrapped in { statusCode, data: {...} } or direct
  return (response as any)?.data || response;
} 